import React from "react";
import { Link } from "react-router-dom";
import Marquee from "react-fast-marquee";
import {
  FaLinkedinIn,
  FaInstagram,
  FaFacebookF,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

import Bg from "../../../images/bg/da-footer.jpg";
import logo from "../../../images/logo/log112.png";

const ClickHandler = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

const Footer = () => {
  return (
    <footer
      className="footer footer-style-six"
      style={{ backgroundImage: `url(${Bg})` }}
    >
      {/* ===== MARQUEE CTA (FIXED HEIGHT) ===== */}
      <div className="da-footer-title">
        <Marquee
          speed={40}
          gradient={false}
          pauseOnHover
          className="footer-marquee"
        >
          <Link
            to="/contact"
            onClick={ClickHandler}
            className="footer-marquee-link"
          >
            <span className="footer-marquee-text">
              Join Our Global AI Conferences
              <span className="highlight">
                Supply Chain • Energy • Digital Transformation
              </span>
              Join Our Global AI Conferences
              <span className="highlight">
                Supply Chain • Energy • Digital Transformation
              </span>
            </span>
          </Link>
        </Marquee>
      </div>

      <div className="container">
        <div className="footer-card">

          {/* CONTACT GRID */}
          <div className="footer-grid">
            <div className="footer-contact-box">
              <span className="label">Production Team</span>
              <h6>Ben Scott</h6>
              <p>Conference Producer</p>
              <a href="mailto:ben.scott@aroevents.com">ben.scott@aroevents.com</a>
            </div>

            <div className="footer-contact-box">
              <span className="label">Sponsorship & Media</span>
              <h6>Amy Wilson</h6>
              <p>Sponsorship Director</p>
              <a href="mailto:amy.wilson@aroevents.com">amy.wilson@aroevents.com</a>
            </div>

            <div className="footer-contact-box">
              <span className="label">Delegate Registration</span>
              <h6>Tom Harris</h6>
              <p>Delegate Sales Manager</p>
              <a href="mailto:tom.harris@aroevents.com">tom.harris@aroevents.com</a>
            </div>

            <div className="footer-contact-box">
              <span className="label">General Inquiries</span>
              <h6>Support Team</h6>
              <p>Event Assistance</p>
              <a href="mailto:info@aroevents.com">info@aroevents.com</a>
            </div>
          </div>

          <div className="footer-divider" />

          {/* BRAND + NAV */}
          <div className="footer-brand">
            <Link to="/" onClick={ClickHandler} className="logo-pill">
              <img src={logo} alt="ARO Events" />
            </Link>

            <nav className="footer-nav">
              <Link to="/" onClick={ClickHandler}>Home</Link>
              <Link to="/about" onClick={ClickHandler}>About</Link>
              <Link to="/contact" onClick={ClickHandler}>Contact</Link>
            </nav>
          </div>

          {/* SOCIAL ICONS */}
          <ul className="footer-socials">
            <li><a href="https://www.linkedin.com/company/aro-events/" target="_blank" rel="noreferrer"><FaLinkedinIn /></a></li>
            <li><a href="https://www.instagram.com/aro_events_/" target="_blank" rel="noreferrer"><FaInstagram /></a></li>
            <li><a href="https://www.facebook.com/share/16jvYa6rF7/" target="_blank" rel="noreferrer"><FaFacebookF /></a></li>
            <li><a href="https://x.com/AroEvents" target="_blank" rel="noreferrer"><FaXTwitter /></a></li>
          </ul>

          <div className="footer-divider" />

          {/* LEGAL */}
          <div className="footer-legal">
            <p>© {new Date().getFullYear()} ARO Events. All rights reserved.</p>
            <div className="footer-links">
              <Link to="/terms-conditions">Terms</Link>
              <Link to="/privacy-policy">Privacy</Link>
              <Link to="/code-of-conduct">Code of Conduct</Link>
            </div>
          </div>

        </div>
      </div>
    </footer>
  );
};

export default Footer;
